<template>
  <div class="ki-page">
    <!-- Main Content -->
    <main>
      <!-- KI Overview Section -->
      <section class="overview-section">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="section-content">
                <span class="subtitle">Intelligente Automation</span>
                <h2>Maßgeschneiderte <span class="text-gradient">KI-Lösungen</span> für Ihren Erfolg</h2>
                <div class="feature-icon mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                    <path fill="#1DAAE4" d="M320 0c17.7 0 32 14.3 32 32V96H480c17.7 0 32 14.3 32 32v64H576c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H512v80c0 17.7-14.3 32-32 32H352V384H288v96H160c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H128V128c0-17.7 14.3-32 32-32H288V32c0-17.7 14.3-32 32-32zM176 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H320zM464 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H464z"/>
                  </svg>
                </div>
                <p>Künstliche Intelligenz ist nicht länger ein Zukunftsthema, sondern ein entscheidender Wettbewerbsfaktor für moderne Unternehmen. Wir bieten maßgeschneiderte KI-Lösungen, die Ihre Geschäftsprozesse optimieren, Kosten senken und neue Erkenntnisse aus Ihren Daten gewinnen.</p>
                <p>Unser Expertenteam begleitet Sie von der ersten Beratung über die Implementierung bis hin zur kontinuierlichen Optimierung und stellt sicher, dass Ihre KI-Lösung genau auf Ihre Anforderungen zugeschnitten ist.</p>
                <div class="stats-container">
                  <div class="stat-item">
                    <span class="stat-number">35%</span>
                    <span class="stat-text">Effizienzsteigerung</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-number">40%</span>
                    <span class="stat-text">Kostenreduktion</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-number">95%</span>
                    <span class="stat-text">Genauigkeit</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="image-container">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="img-fluid" width="100%" height="300">
                  <path fill="#1DAAE4" d="M320 0c17.7 0 32 14.3 32 32V96H480c17.7 0 32 14.3 32 32v64H576c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H512v80c0 17.7-14.3 32-32 32H352V384H288v96H160c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H128V128c0-17.7 14.3-32 32-32H288V32c0-17.7 14.3-32 32-32zM176 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H320zM464 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H464z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- KI Benefits Section -->
      <section class="benefits-section">
        <div class="container">
          <div class="section-title text-center">
            <span class="subtitle">Ihre Vorteile</span>
            <h2>Warum Sie auf <span class="text-gradient">KI</span> setzen sollten</h2>
          </div>
          
          <div class="row mt-5">
            <div class="col-md-4 mb-4">
              <div class="benefit-card">
                <div class="benefit-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                    <path fill="#1DAAE4" d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                  </svg>
                </div>
                <h3>Verbesserte Entscheidungsfindung</h3>
                <p>Nutzen Sie KI-gestützte Analysen und Vorhersagen für fundierte Geschäftsentscheidungen in Echtzeit.</p>
                <ul class="benefit-features">
                  <li>Datengestützte Entscheidungen</li>
                  <li>Bessere Risikoeinschätzung</li>
                  <li>Frühzeitige Erkennung von Trends</li>
                </ul>
              </div>
            </div>
            
            <div class="col-md-4 mb-4">
              <div class="benefit-card">
                <div class="benefit-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                    <path fill="#1DAAE4" d="M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75H192 160 64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352l8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32zM416 440.8L360.4 385.2c-57.1-57.1-134.9-89.1-216-89.1H128V128h16.4c81.2 0 158.9-32.1 216-89.1L416 83.2V440.8z"/>
                  </svg>
                </div>
                <h3>Automatisierung von Prozessen</h3>
                <p>Automatisieren Sie repetitive Aufgaben und komplexe Prozesse, um Ihre Mitarbeiter zu entlasten und Fehler zu reduzieren.</p>
                <ul class="benefit-features">
                  <li>Höhere Prozesseffizienz</li>
                  <li>Senkung manueller Fehler</li>
                  <li>Fokus auf wertschöpfende Tätigkeiten</li>
                </ul>
              </div>
            </div>
            
            <div class="col-md-4 mb-4">
              <div class="benefit-card">
                <div class="benefit-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                    <path fill="#1DAAE4" d="M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3 .7 8.5 2.1 12.5l30.2 87.5c4.6 13.3 19.4 20.3 32.7 15.7s20.3-19.4 15.7-32.7l-30.2-87.5-.2-.6V214.4c17.3-3.6 34.1-9.4 50.3-17.3l15.2-7.4c12.2-6 17.5-20.7 11.5-32.9s-20.7-17.5-32.9-11.5l-15.2 7.4c-46 22.4-99.5 22.4-145.4 0L161.5 169.9zM128 320v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm192 0v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32z"/>
                  </svg>
                </div>
                <h3>Wettbewerbsvorteil</h3>
                <p>Verschaffen Sie sich einen Vorsprung durch innovative KI-Lösungen, die Kundenbedürfnisse antizipieren und personalisieren.</p>
                <ul class="benefit-features">
                  <li>Personalisierte Kundenansprache</li>
                  <li>Innovative Produkte und Services</li>
                  <li>Agilität und Anpassungsfähigkeit</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- KI Technologies Section -->
      <section class="technologies-section">
        <div class="container">
          <div class="section-title text-center">
            <span class="subtitle">Unsere Technologien</span>
            <h2>Moderne <span class="text-gradient">KI-Tools</span> für anspruchsvolle Projekte</h2>
            <p class="lead">Wir setzen auf bewährte Open-Source- und Enterprise-Technologien für KI-Entwicklung</p>
          </div>
          
          <div class="row mt-5">
            <div class="col-md-3 col-sm-6 mb-4">
              <div class="tech-card">
                <div class="tech-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512">
                    <path fill="currentColor" d="M320 0c17.7 0 32 14.3 32 32V96H480c17.7 0 32 14.3 32 32v64H576c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H512v80c0 17.7-14.3 32-32 32H352V384H288v96H160c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H128V128c0-17.7 14.3-32 32-32H288V32c0-17.7 14.3-32 32-32z"/>
                  </svg>
                </div>
                <h5 class="tech-title">LangChain</h5>
                <p class="tech-desc">Framework zum Entwickeln von Anwendungen mit Large Language Models (LLMs) durch Komponenten-Verkettung.</p>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 mb-4">
              <div class="tech-card">
                <div class="tech-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512">
                    <path fill="currentColor" d="M96 0C60.7 0 32 28.7 32 64V352c0 35.3 28.7 64 64 64H234.8c-5-9.6-9.2-19.8-12.5-30.5c-4.6-14.3-7.1-29.3-8.1-44.2c-2.6-3.4-5.1-6.9-7.3-10.4c-14.7-22.9-23.5-50.2-23.5-79.5c0-79.5 64.5-144 144-144c37.2 0 71.2 14.1 96.7 37.4c4.7-11.5 7.3-24.1 7.3-37.3c0-53-43-96-96-96H368 320 272 219.8 171.2 64C46.3 32 32 46.3 32 64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V96h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V96h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V96h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H400 352 304 251.8 203.2 96zM592 384c0-87.4-71.6-158.4-160-158.4c-88.4 0-160 71-160 158.4c0 87.4 71.6 158.4 160 158.4c88.4 0 160-71 160-158.4zM391.8 286.9L352 368l-39.8-81.1c-5.7-11.5-19.8-14.8-29.9-7.1c-9.2 7.2-10.1 20.3-2.8 29.6L319 368l-81.1 39.8c-11.5 5.7-14.8 19.8-7.1 29.9c7.2 9.2 20.3 10.1 29.6 2.8l59.4-39.7 39.9 81.1c5.7 11.5 19.8 14.8 29.9 7.1c10-7.8 10.8-22.3 1.7-31.1L353.1 400l81.1-39.8c11.5-5.7 14.8-19.8 7.1-29.9c-7.2-9.2-20.3-10.1-29.6-2.8L371.2 368l-39.9-81.1c-5.7-11.5-19.8-14.8-29.9-7.1c-9.2 7.2-10.1 20.3-2.8 29.6l32.3 59.3 0 0 0 0 0 0-.2-.4 .2 .4 0 0 0 0 0 0z"/>
                  </svg>
                </div>
                <h5 class="tech-title">Pydantic AI</h5>
                <p class="tech-desc">Tool zur Strukturierung, Validierung und Optimierung von Prompt-Engineering mit starker Typisierung.</p>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 mb-4">
              <div class="tech-card">
                <div class="tech-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512">
                    <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
                  </svg>
                </div>
                <h5 class="tech-title">RAG</h5>
                <p class="tech-desc">Ansatz zur Erweiterung von LLMs mit aktuellen, relevanten Dokumenten für präzisere Antworten.</p>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 mb-4">
              <div class="tech-card">
                <div class="tech-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512">
                    <path fill="currentColor" d="M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z"/>
                  </svg>
                </div>
                <h5 class="tech-title">Vecs</h5>
                <p class="tech-desc">Moderne Vektordatenbank für semantische Suchen und ähnlichkeitsbasierte Abfragen in AI-Anwendungen.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Integrated Components Section -->
      <section class="integrated-components-section">
        <div class="container">
          <div class="section-title text-center">
            <span class="subtitle">Ganzheitlicher Ansatz</span>
            <h2>KI und <span class="text-gradient">DevOps</span> vereint</h2>
            <p class="lead">Erfahren Sie mehr über unsere integrierten Lösungen auf der Startseite</p>
          </div>
          
          <div class="cta-buttons animated fadeInUp mt-5 text-center">
            <a href="/#services" class="btn-primary mx-2">Zu unseren Leistungen</a>
            <a href="/#erfolgsgeschichten" class="btn-secondary mx-2">Erfolgsgeschichten anschauen</a>
            <a href="/#referenzen" class="btn-outline mx-2">Kundenstimmen hören</a>
          </div>
        </div>
      </section>

      <!-- CTA Section -->
      <section class="cta-section">
        <div class="container text-center">
          <h2>Bereit, in die KI-Zukunft zu starten?</h2>
          <p>Kontaktieren Sie uns für ein unverbindliches Beratungsgespräch zu Ihren KI-Möglichkeiten.</p>
          <a href="/#kontakt" class="btn-primary">Beratungsgespräch vereinbaren</a>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'AppKi'
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

.ki-page {
  overflow-x: hidden;
}

.overview-section {
  background: linear-gradient(180deg, darken($background-color, 3%), $background-color);
  padding: 100px 0;
}

.section-content {
  .subtitle {
    display: inline-block;
    color: $accent-color;
    font-weight: 600;
    margin-bottom: 15px;
    font-size: 1.1rem;
    position: relative;
    padding-left: 15px;
    
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 5px;
      height: 20px;
      background: $accent-gradient;
      border-radius: 3px;
    }
  }
  
  h2 {
    font-size: 2.5rem;
    margin-bottom: 20px;
    color: $heading-color;
  }
  
  p {
    color: $muted-text-color;
    margin-bottom: 20px;
    font-size: 1.1rem;
    line-height: 1.6;
  }
}

.stats-container {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  
  .stat-item {
    text-align: center;
    
    .stat-number {
      display: block;
      font-size: 2.5rem;
      font-weight: 700;
      color: $accent-color;
      margin-bottom: 5px;
    }
    
    .stat-text {
      color: $muted-text-color;
      font-size: 0.9rem;
    }
  }
}

.image-container {
  position: relative;
  
  svg {
    filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.3));
  }
  
  &::before {
    content: '';
    position: absolute;
    width: 120%;
    height: 120%;
    top: -10%;
    left: -10%;
    background: radial-gradient(circle at center, rgba($accent-color, 0.1), transparent 70%);
    z-index: -1;
  }
}

// Benefits Section
.benefits-section {
  padding: 100px 0;
  background: linear-gradient(0deg, rgba($accent-color, 0.03), rgba($primary-color, 0.1));
}

.benefit-card {
  background: rgba($secondary-color, 0.4);
  border-radius: 15px;
  padding: 30px;
  height: 100%;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  border: 1px solid rgba($accent-color, 0.1);
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
    border-color: rgba($accent-color, 0.3);
  }
  
  .benefit-icon {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 25px;
    background: linear-gradient(135deg, rgba($accent-color, 0.1), rgba($accent-color, 0.05));
    border-radius: 50%;
    
    svg {
      filter: drop-shadow(0 4px 6px rgba($accent-color, 0.2));
    }
  }
  
  h3 {
    font-size: 1.4rem;
    color: $accent-color;
    margin-bottom: 15px;
    text-align: center;
  }
  
  p {
    color: $muted-text-color;
    text-align: center;
    margin-bottom: 20px;
  }
}

.benefit-features {
  list-style: none;
  padding-left: 0;
  
  li {
    padding: 8px 0;
    position: relative;
    padding-left: 25px;
    color: $text-color;
    
    &::before {
      content: '✓';
      position: absolute;
      left: 0;
      color: $accent-color;
    }
  }
}

// Technologies Section
.technologies-section {
  padding: 100px 0;
  background: linear-gradient(180deg, $background-color, darken($background-color, 3%));
}

.tech-card {
  background: rgba($secondary-color, 0.6);
  border-radius: 15px;
  padding: 25px 15px;
  text-align: center;
  height: 100%;
  transition: all 0.3s ease;
  border: 1px solid rgba($accent-color, 0.1);
  
  &:hover {
    transform: translateY(-10px);
    border-color: rgba($accent-color, 0.3);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
  
  .tech-icon {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    padding: 15px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba($accent-color, 0.1), rgba($accent-color, 0.05));
    color: $accent-color;
  }
  
  .tech-title {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 10px;
    color: $heading-color;
  }
  
  .tech-desc {
    font-size: 0.9rem;
    color: $muted-text-color;
    margin: 0;
  }
}

// Integrated Components Section
.integrated-components-section {
  padding: 100px 0;
  background: linear-gradient(0deg, rgba($accent-color, 0.03), rgba($primary-color, 0.1));
  
  .lead {
    color: $muted-text-color;
    max-width: 700px;
    margin: 0 auto;
    font-size: 1.1rem;
  }
}

.btn-outline {
  background: transparent;
  color: $accent-color;
  border: 2px solid $accent-color;
  padding: 12px 28px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  text-decoration: none;
  
  &:hover {
    background: rgba($accent-color, 0.1);
    transform: translateY(-3px);
  }
}

// CTA Section
.cta-section {
  background: $primary-color;
  padding: 80px 0;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle at center, rgba($accent-color, 0.1), transparent 70%);
    z-index: 0;
  }
  
  h2 {
    color: white;
    margin-bottom: 20px;
    position: relative;
    z-index: 1;
  }
  
  p {
    color: $muted-text-color;
    max-width: 600px;
    margin: 0 auto 30px;
    position: relative;
    z-index: 1;
  }
}

// Responsive styles
@media (max-width: 992px) {
  .stats-container {
    flex-direction: column;
    
    .stat-item {
      margin-bottom: 20px;
    }
  }
}

@media (max-width: 768px) {
  .section-content h2 {
    font-size: 2rem;
  }
  
  .tech-grid {
    grid-template-columns: 1fr !important;
  }
  
  .benefit-card {
    margin-bottom: 30px;
  }
}

.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
</style>